import { useAccountRequestCreatePageProps } from "./fetch";
import { AccountRequestCreatePage as UI } from "./ui";

export const AccountRequestCreatePage = () => {
  const props = useAccountRequestCreatePageProps();
  return <UI {...props} />;
};
